import { TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

import CondenseTableCell from '@/components/CondenseTableCell';
import IconTooltip from '@/components/IconTooltip';
import {
  AVG_TICKET_KEY,
  NR_RECEIPTS_KEY,
} from '@/features/anonymousPurchasesStatistics/consts/keys';
import { TIMEFRAME_KEY } from '@/features/statistics/consts/keys';

const HeadRow = ({ SortControl }) => (
  <TableRow>
    <CondenseTableCell>
      <SortControl field={TIMEFRAME_KEY}>Дата</SortControl>
    </CondenseTableCell>
    <CondenseTableCell align="right">
      <IconTooltip title="Количество покупок">
        <SortControl field={NR_RECEIPTS_KEY}>Покупки</SortControl>
      </IconTooltip>
    </CondenseTableCell>
    <CondenseTableCell align="right">
      <IconTooltip title="Средний чек">
        <SortControl field={AVG_TICKET_KEY}>Средний чек</SortControl>
      </IconTooltip>
    </CondenseTableCell>
    <CondenseTableCell align="right">
      <IconTooltip title="Распределение по времени покупки">
        Распределение по времени покупки
      </IconTooltip>
    </CondenseTableCell>
  </TableRow>
);

HeadRow.propTypes = {
  SortControl: PropTypes.func.isRequired,
};

export default HeadRow;
